export default __webpack_public_path__ + "static/media/node.8b12cade.svg";